module.exports = __webpack_public_path__ + "img/cards_square_top.8093b58f.svg";